import { useState } from "react";
import { Button } from "V2.0/common/button";
import { Switch } from "V2.0/common/switch";
import InputComponent from "V2.0/components/InputComponent";

function ClarificationResponsesEnableSwitch(props) {
  const { isClarificationResponsesEnabled, onUpdate, disabled } = props;

  function handleUpdateClarificationResponsesEnabled() {
    onUpdate({
      clarificationResponsesEnabled: !isClarificationResponsesEnabled,
    });
  }

  return (
    <Switch
      color="green"
      disabled={disabled}
      checked={isClarificationResponsesEnabled}
      onChange={handleUpdateClarificationResponsesEnabled}
    />
  );
}

export default function ClarificationResponses(props) {
  const { voiceCache, onSave, locked } = props;

  const [settings, setSettings] = useState({
    clarificationResponsesEnabled: voiceCache.clarificationResponsesEnabled,
    clarificationResponses: voiceCache.clarificationResponses,
    clarificationReleaseTimeout:
      voiceCache.clarificationReleaseTimeout &&
      voiceCache.clarificationReleaseTimeout > 2800
        ? voiceCache.clarificationReleaseTimeout
        : 2800,
  });

  const [errors, setErrors] = useState({
    clarificationReleaseTimeout: null,
  });

  function handleUpdateError(modifiedError) {
    setErrors((prevErrors) => {
      return {
        ...prevErrors,
        ...modifiedError,
      };
    });
  }

  function handleUpdate(updatedSetting) {
    setSettings((prevSettings) => {
      return {
        ...prevSettings,
        ...updatedSetting,
      };
    });
  }

  function handleUpdateClarificationResponses(e) {
    setSettings((prevSettings) => {
      return {
        ...prevSettings,
        clarificationResponses: e.target.value,
      };
    });
  }

  function handleUpdateClarificationReleaseTimeout(e) {
    const clarificationReleaseTimeout = e.target.value;
    if (Number(e.target.value) < 2800) {
      handleUpdateError({
        clarificationReleaseTimeout: "Minimum timeout is 2800 ms",
      });
    } else if (
      errors["clarificationReleaseTimeout"] &&
      clarificationReleaseTimeout >= 2800
    ) {
      handleUpdateError({
        clarificationReleaseTimeout: null,
      });
    }

    setSettings((prevSettings) => {
      return {
        ...prevSettings,
        clarificationReleaseTimeout: e.target.value,
      };
    });
  }

  function handleSave() {
    const transformedResponses = Array.isArray(settings.clarificationResponses)
      ? settings.clarificationResponses
      : settings.clarificationResponses.split(",");
    onSave({
      ...settings,
      clarificationResponses: transformedResponses,
    });
  }

  const isSaveDisabled = Object.values(errors).some((value) => !!value);

  return (
    <div className="border rounded-lg w-full">
      <div className="bg-gray-50 px-6 py-4 rounded-t-lg space-y-2">
        <p className="text-base font-medium">Clarification Responses</p>
        <p className="text-sm text-gray-500">
          Short clarifying phrases (e.g., “Could you clarify that?”, “What do
          you mean?”) the assistant uses when user's response isn’t clear.
        </p>
      </div>
      <div className="px-8 py-4 grid grid-cols-3 space-y-4">
        <div className="col-span-3 flex items-center gap-x-2">
          <p className="font-medium">Use Clarification Responses</p>
          <ClarificationResponsesEnableSwitch
            isClarificationResponsesEnabled={
              settings.clarificationResponsesEnabled
            }
            onUpdate={handleUpdate}
            disabled={locked}
          />
        </div>

        <div className="col-span-3 xl:col-span-2 ml-4">
          <InputComponent
            type="textArea"
            label="Enter Responses (comma-seperated)"
            placeholder="Sorry?, Could you please repeat?, Excuse me?"
            disabled={locked || !settings.clarificationResponsesEnabled}
            onChange={handleUpdateClarificationResponses}
            value={settings.clarificationResponses}
            style={{ height: "100px", fontSize: "13px" }}
          />
        </div>

        <div className="col-span-3 grid grid-cols-3 ml-4">
          <div className="col-span-2 xl:col-span-1">
            <InputComponent
              type="number"
              min="2800"
              label="Clarification Release Timeout (Milliseconds)"
              disabled={locked || !settings.clarificationResponsesEnabled}
              onChange={handleUpdateClarificationReleaseTimeout}
              value={settings.clarificationReleaseTimeout}
              invalid={!!errors.clarificationReleaseTimeout}
              error={errors.clarificationReleaseTimeout}
            />
          </div>
        </div>
      </div>
      <div className="bg-gray-50 px-6 py-3 text-right rounded-b-lg">
        {!locked && <Button onClick={handleSave} disabled={isSaveDisabled}>Save</Button>}
      </div>
    </div>
  );
}
